module.exports = __webpack_public_path__ + "static/faktum-semibold-5626003aaa65656deb763b95ebac3edd.woff";